import * as React from "react";
import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import { getBackend } from "../../api/backend";
import { CircularProgress } from "@mui/material";

export default function FourthChart() {
  const [chartData, setChartData] = React.useState({ value: 0, valueMax: 0 });
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getBackend("workorders-monthly-data/");
        setChartData(data);
        console.log(data)
      } catch (error) {
        console.error("Error fetching the chart data", error);
      } 
    };

    fetchData().then(() => setIsLoading(false));
  }, []);

  return isLoading ? <CircularProgress/> : (
    <Gauge
      value={chartData.value}
      valueMax={chartData.valueMax}
      startAngle={-110}
      endAngle={110}
      height={300}
      cornerRadius="15%"
      sx={{
        [`& .${gaugeClasses.valueArc}`]: {
          fill: chartData.status_color,
        },
        [`& .${gaugeClasses.valueText}`]: {
          fontSize: 30,
          transform: "translate(0px, -30px)",
        },
      }}
      // Add logging to check if values are being passed correctly to the Gauge
      text={({ value, valueMax }) => `OT Terminadas: ${value} / ${valueMax}`}
    />
  );
}